import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  TemplateRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CarLicenseEnum } from 'server/shared/models/carLicense.enum';

@Component({
  selector: 'app-mobility-select',
  templateUrl: './mobility-select.component.html',
  styleUrls: ['./mobility-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MobilitySelectComponent,
      multi: true,
    },
  ],
})
export class MobilitySelectComponent implements ControlValueAccessor {
  readonly carLicenseEnum = CarLicenseEnum;
  isDisabled$ = new BehaviorSubject<boolean>(false);
  selectedValue$ = new BehaviorSubject<CarLicenseEnum | undefined>(undefined);

  @ContentChild('hint') hintContent?: TemplateRef<any>;

  onChange: any = (carLicense: CarLicenseEnum) => {};
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  onTouch: any = () => {};
  registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }

  constructor() {}

  setDisabledState(isDisabled: boolean) {
    this.isDisabled$.next(isDisabled);
  }

  writeValue(value: CarLicenseEnum) {
    this.selectedValue$.next(value);
  }

  selectionChanged(carLicence: CarLicenseEnum) {
    this.selectedValue$.next(carLicence);
    this.onChange(carLicence);
  }
}
